import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/FacebookRounded';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export const Contacts = [
	{
		href: 'https://wa.me/+201205224238',
		icon: WhatsAppIcon,
	},
	{
		href: 'mailto:kerolos1410@gmail.com',
		icon: EmailIcon,
	},
	{
		href: 'https://www.linkedin.com/in/kerolos-magdy-314644212/',
		icon: LinkedInIcon,
	},
	{
		href: 'https://github.com/Kerolos2000',
		icon: GitHubIcon,
	},
	{
		href: 'https://www.facebook.com/profile.php?id=100085254521149',
		icon: FacebookIcon,
	},
];
